import React, { useState, Fragment, useEffect } from 'react';
import {
    Row,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    CustomInput
} from 'reactstrap';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import { gAPI_TemplateServicesList } from '../../../../../../constants/APIs';
import ServicesThumbListView from './ServicesThumbListView';

export function TemplateServiceList({
    visible,
    toggle,
    formLabel,
    submit,
    updatePormosData,
    propertyId,
    domainName,
    isServiceOrder,
    languageCode
}) {

    const [servicesData, setservicesData] = useState([]);
    const [selectedItems, setselectedItems] = useState([]);
    const [lastChecked, setlastChecked] = useState(null);
    useEffect(() => {
        let domainname = "";
        if (domainName.length > 0) {
            domainname = domainName[0].type;
        }
        if (domainname !== undefined && domainname !== "") {
            AxiosAPI({
                method: 'get',
                url: `${gAPI_TemplateServicesList}?domain=${domainname}&languageCode=${languageCode}&guestService=${isServiceOrder}`,
            })
                .then(res => {
                    let service = res.data;
                    // if (isServiceOrder === true) {
                    //     service = res.data.filter((item) => item.serviceType === "ServiceOrder");
                    // }
                    // else {
                    //     service = res.data.filter((item) => item.serviceType === "AddOnUpsells");
                    // }
                    setservicesData(service);
                })
                .catch(err => console.log('err', err));
        }
    }, [domainName]);

    const handleSubmit = () => {
        var data = {
            groupId: getGroupID(),
            propertyId: propertyId,
            services: selectedItems
        }
        submit(data);
    };

    const onCheckItem = (event, id) => {
        if (
            event.target.tagName === "A" ||
            (event.target.parentElement && event.target.parentElement.tagName === "A")
        ) {
            return true;
        }
        if (lastChecked === null) {
            setlastChecked({ lastChecked: id })
        }

        let selitems = selectedItems;
        if (selitems.includes(id)) {
            selitems = selitems.filter(x => x !== id);
        } else {
            selitems.push(id);
        }
        setselectedItems([...selitems])
        document.activeElement.blur();
    };

    const handleChangeSelectAll = isToggle => {
        if (selectedItems.length >= servicesData.length) {
            if (isToggle) {
                setselectedItems([])
            }
        } else {
            let selitems = []
            servicesData.map(x => selitems.push(x.id))
            setselectedItems([...selitems])
        }
        document.activeElement.blur();
        return false;
    };

    return (
        <Fragment>
            <Modal isOpen={visible} toggle={toggle} size="lg">
                <ModalHeader toggle={toggle}>{formLabel}</ModalHeader>
                <ModalBody>
                    <Row>
                        <Colxx xxs="12">
                            <div className="mb-2">
                                <div className="text-zero">
                                    <div className="pr-0 check-button check-all">
                                        <CustomInput
                                            className="custom-checkbox mb-0 d-inline-block"
                                            type="checkbox"
                                            id="checkAll"
                                            checked={selectedItems.length >= servicesData.length}
                                            onChange={() => handleChangeSelectAll(true)}
                                            label="Select All"
                                        />
                                    </div> </div> </div> </Colxx></Row>

                    <Row>
                        {servicesData !== undefined && servicesData.length > 0 && servicesData.map(service => {
                            return (
                                <ServicesThumbListView
                                    key={service.id}
                                    service={service}
                                    isSelect={selectedItems.includes(service.id)}
                                    onCheckItem={onCheckItem}
                                />
                            );
                        }
                        )}
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <p> These will be added with inactive status, you can edit and make them active when you ready </p>
                    <Button color="primary" onClick={handleSubmit}>
                        Add Selected
                    </Button>
                    <Button color="secondary" onClick={toggle}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
        </Fragment>)
};